var _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgParabola = function SvgParabola(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 24,
    viewBox: "0 0 196 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.976 0L196 24H171.951L183.976 0Z",
    fill: "#A0D8FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.699 0H155.116V15.6H146.699V0Z",
    fill: "#A0D8FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.699,
    y: 15.6006,
    width: 8.41718,
    height: 8.4,
    fill: "#42B2FD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 155.116,
    y: 15.6006,
    width: 12.0245,
    height: 8.4,
    fill: "#A0D8FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.865 24C136.506 24 141.89 18.6274 141.89 12C141.89 5.37258 136.506 0 129.865 0C123.224 0 117.841 5.37258 117.841 12C117.841 18.6274 123.224 24 129.865 24Z",
    fill: "#A0D8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1963 3.05176e-05H105.231C109.539 3.05176e-05 113.031 3.49202 113.031 7.79961C113.031 12.1072 109.539 15.5992 105.231 15.5992H96.1963V3.05176e-05ZM96.1963 8.40004H105.231C109.539 8.40004 113.031 11.892 113.031 16.1996C113.031 20.5072 109.539 23.9992 105.231 23.9992H96.1963V8.40004Z",
    fill: "#A0D8FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1963 8.40088V15.6H105.231C107.992 15.6 110.418 14.1652 111.804 12.0004C110.418 9.83571 107.992 8.40088 105.231 8.40088H96.1963Z",
    fill: "#42B2FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3624 0L91.387 24H67.3379L79.3624 0Z",
    fill: "#A0D8FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6936 0.000100938L45.6934 -0.000228882V0.000100938V15.5993V23.9998H62.5277L56.4944 15.3984C59.9512 14.5981 62.5277 11.4998 62.5277 7.79968C62.5277 3.49209 59.0357 0.000100938 54.7281 0.000100938H45.6936Z",
    fill: "#A0D8FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6934 3.05176e-05V15.5992H54.7281C55.3356 15.5992 55.9269 15.5297 56.4944 15.3983L45.6936 3.05176e-05H45.6934Z",
    fill: "#42B2FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8595 0L40.884 24H16.835L28.8595 0Z",
    fill: "#A0D8FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41718 0.000132232H9.01883C13.3352 0.000132232 16.8344 3.49212 16.8344 7.79971C16.8344 12.1073 13.3352 15.5993 9.01883 15.5993H8.41718V24.0001H0V0H8.41718V0.000132232Z",
    fill: "#A0D8FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.41718,
    height: 15.6,
    fill: "#42B2FD"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgParabola);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";